import React from 'react';
interface IProps {
  routes: React.ReactNode
}
const Router = ({ routes }: IProps) => <>{ routes }</>;

export default Router;
